export default `# Drelo — Política de Devoluciones y Reembolsos (Borrador)

**Última actualización:** 23 de junio de 2026

## Ventana de devolución

Puedes solicitar una devolución dentro de los **14 días** posteriores a la fecha de entrega, siempre que el producto esté sin usar y en su empaque original.

## Productos no elegibles para devolución

- Productos de higiene personal o que hayan estado en contacto directo con la piel (ej. ciertos productos de cuidado personal/belleza), salvo defecto de fábrica.
- Productos en oferta marcados explícitamente como "venta final".

## Producto dañado, defectuoso o incorrecto

Si recibes un producto dañado, defectuoso, o distinto al que ordenaste, contáctanos dentro de **7 días** de recibido con fotos del producto y empaque — te ofreceremos reemplazo o reembolso completo sin costo para ti.

## Cómo solicitar una devolución

1. Escríbenos a soporte@drelo.shop con tu número de orden y motivo de la devolución.
2. Te indicaremos si debes regresar el producto físicamente (a la dirección que te proporcionemos) o si el reembolso se procesa directamente, según el caso.
3. Una vez aprobada, el reembolso se procesa a tu método de pago original dentro de **5-10 días hábiles**.

## Costos de envío de devolución

Salvo en casos de producto dañado/defectuoso/incorrecto, el costo de envío de devolución corre por cuenta del comprador. Los costos de envío originales no son reembolsables.

## Cancelaciones

Puedes cancelar tu pedido sin costo solo si aún no ha sido despachado por el proveedor. Una vez despachado, aplica la política de devolución estándar.

## Contacto

soporte@drelo.shop — incluye siempre tu número de orden.
`;
